import { createStore } from "vuex";
import axios from "axios";

const { v4: uuidv4 } = require("uuid");

const store = createStore({
  state: {
    uuid: null,
    token: null,
  },
  mutations: {
    setUUID(state, payload) {
      state.uuid = payload;
    },
    setTOKEN(state, payload) {
      state.token = payload;
    },
    setBillData(state, data) {
      state.billData = data;
    },
    resetBillData(state) {
      state.billData = null;
    }
  },
  actions: {
    setUUID({ commit }, payload) {
      if (payload) {
        commit("setUUID", payload);
      } else {
        commit("setUUID", uuidv4());
      }
    },
    async setTOKEN({ commit }, payload) {
      if (payload) {
        commit("setTOKEN", payload);
        const url = `${process.env.VUE_APP_BASE_URL}/v2/api/user/me`;
        try {
          const { data } = await axios.get(url, { headers: { Authorization: "Bearer " + payload } })
          localStorage.setItem("user", JSON.stringify(data.value));
        } catch (e) {
          console.log(e)
        }
      }
    },
    updateBillData({ commit }, data) {
      commit('setBillData', data);
    },
  },
  modules: {},
  getters: {
    UUID: (state) => state.uuid,
    token: (state) => state.token,
  },
});

export default store;
